
import {
  Component,
  Vue
} from 'vue-property-decorator'
import {
  BreadcrumbModule
} from '@/store/modules/BreadcrumbModule'
import lazyLoad from '@/components/LazyLoad'
  @Component({
    name: 'Barge'
  })
export default class Barge extends Vue {
    protected type: any = null

    created () {
      this.boot()
    }

    get component () {
      if (this.type === 'Inventory') {
        return () => lazyLoad(import('./components/Inventory.vue'))
      }

      if (this.type === 'Transfer') {
        return () => lazyLoad(import('./components/Transfer.vue'))
      }

      if (this.type === 'Master') {
        return () => lazyLoad(import('./components/Master.vue'))
      }
    }

    protected async boot () {
      BreadcrumbModule.setBreadcrumb(this.$route)
      this.type = 'Inventory'
    }
}

